import { useEffect, useState } from "react";

import { authGateway } from "../lib/AuthGateway";
import type { AuthConfiguration } from "../lib/AuthGateway";

interface AuthConfigurationState {
  configuration: AuthConfiguration | null;
  configurationError: boolean;
}

export function useAuthConfiguration(): AuthConfigurationState {
  const [configuration, setConfiguration] = useState<AuthConfiguration | null>(
    null,
  );
  const [configurationError, setConfigurationError] = useState(false);

  useEffect(() => {
    let active = true;
    void authGateway
      .getConfiguration()
      .then((value) => {
        if (!active) return;
        setConfiguration(value);
        setConfigurationError(false);
      })
      .catch(() => {
        if (!active) return;
        setConfiguration(null);
        setConfigurationError(true);
      });
    return () => {
      active = false;
    };
  }, []);

  return { configuration, configurationError };
}
